var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8854 9.77865C16.3274 9.77865 16.7514 9.60305 17.0639 9.29049C17.3765 8.97793 17.5521 8.55401 17.5521 8.11198C17.5521 7.66995 17.3765 7.24603 17.0639 6.93347C16.7514 6.62091 16.3274 6.44531 15.8854 6.44531C15.4434 6.44531 15.0195 6.62091 14.7069 6.93347C14.3943 7.24603 14.2188 7.66995 14.2188 8.11198C14.2188 8.55401 14.3943 8.97793 14.7069 9.29049C15.0195 9.60305 15.4434 9.77865 15.8854 9.77865Z",
    fill: "#696869"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 4.22222C2 3.63285 2.23413 3.06762 2.65087 2.65087C3.06762 2.23413 3.63285 2 4.22222 2H19.7778C20.3671 2 20.9324 2.23413 21.3491 2.65087C21.7659 3.06762 22 3.63285 22 4.22222V19.7778C22 20.3671 21.7659 20.9324 21.3491 21.3491C20.9324 21.7659 20.3671 22 19.7778 22H4.22222C3.63285 22 3.06762 21.7659 2.65087 21.3491C2.23413 20.9324 2 20.3671 2 19.7778V4.22222ZM19.7778 4.22222H4.22222V13.0222L7.97222 10.0222C8.16929 9.86444 8.41422 9.77847 8.66667 9.77847C8.91912 9.77847 9.16404 9.86444 9.36111 10.0222L14.1389 13.8444L15.6589 12.3256C15.8673 12.1173 16.1498 12.0002 16.4444 12.0002C16.7391 12.0002 17.0216 12.1173 17.23 12.3256L19.7778 14.8733V4.22222ZM4.22222 19.7778H19.7778V18.0156L16.4444 14.6822L15.0078 16.1189C14.8144 16.3123 14.5566 16.4277 14.2835 16.4429C14.0104 16.458 13.7413 16.372 13.5278 16.2011L8.66667 12.3111L4.22222 15.8667V19.7778Z",
    fill: "#696869"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcon);
export default __webpack_public_path__ + "static/media/image-icon.07852f0d37151f850a64e61a2601d203.svg";
export { ForwardRef as ReactComponent };